import env from '../utils/env';
import authWeb from './web';
import authWeixin from './weixin';
import authNative from './native';
import authQuickApp from './quickApp';

function get() {
  if (env.isWeixin) {
    return authWeixin;
  } else if (env.isNative) {
    return authNative;
  } else if (env.isQuickApp) {
    return authQuickApp;
  } else {
    return authWeb;
  }
}

export default get();



// WEBPACK FOOTER //
// ./src/auth/index.js